import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MERCURY_LAYER } from 'HubStyleTokens/sizes';
const UIWellConnector = styled.span.withConfig({
  displayName: "UIWellConnector",
  componentId: "sc-1lz5vxy-0"
})(["position:absolute;top:50%;right:0;transform:translateY(-50%) translateX(50%);z-index:", ";"], MERCURY_LAYER);
UIWellConnector.propTypes = {
  children: PropTypes.node
};
export default UIWellConnector;